import { render, staticRenderFns } from "./EditarEnfermero.vue?vue&type=template&id=5af3aed2"
import script from "./EditarEnfermero.vue?vue&type=script&lang=js"
export * from "./EditarEnfermero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports